const translations = {
  ja: {
    translation: {
      'app.title': 'AI Feel Competency',
      'app.start': '開始',
      'app.admin': '管理画面',
      'app.history': '評価履歴',
      // "app.back": "メイン画面に戻る",
      'app.backToHistory': '履歴に戻る',
      'app.loading': '読み込み中...',
      'app.error': 'エラーが発生しました',
      'app.retry': '再試行',
      'app.yes': 'はい',
      'app.no': 'いいえ',
      'app.neutral': 'どちらでもない',
      'app.unknown': 'よくわからない',
      'app.save': '保存',
      'app.cancel': 'キャンセル',
      'app.competencyAssessment': 'コンピテンシー評価',
      'app.aiAnalysisDescription': 'AIが16の領域であなたの能力を分析\n詳細な評価レポートを即座に生成',

      // コンピテンシー評価ツール
      'assessment.title': 'AI駆動コンピテンシー評価ツール',
      'assessment.subtitle': '革新的なAI技術で、あなたの潜在能力を科学的に分析します',
      'assessment.aiDrivenAnalysis': 'AI駆動分析',
      'assessment.nameLabel': '評価対象者氏名',
      'assessment.namePlaceholder': 'お名前を入力してください',
      'assessment.startButton': 'AI評価を開始する',
      'assessment.progressLabel': '進捗状況',
      'assessment.preparingQuestions': 'AI質問を準備中...',
      'assessment.processing': '処理中...',
      'assessment.welcomeTitle': 'AI駆動コンピテンシー評価へようこそ',
      'assessment.welcomeDescription': '最先端のAI技術を活用して、あなたの能力特性を総合的に評価いたします。',
      'assessment.nextQuestion': '次の質問',
      'assessment.finishAssessment': '評価を完了',
      'assessment.progress': '進捗',
      'assessment.answerScale': '回答スケール',
      'assessment.scale1': '全く当てはまらない',
      'assessment.scale2': 'あまり当てはまらない',
      'assessment.scale3': 'どちらでもない',
      'assessment.scale4': 'やや当てはまる',
      'assessment.scale5': '非常に当てはまる',
      'assessment.analyzing': '分析中...',
      'assessment.generatingResults': '結果を生成中...',
      'assessment.resultsTitle': 'AI分析結果',
      'assessment.overview': '評価の概要',
      'assessment.overviewDescription1': 'このツールは、AIがあなたの回答をリアルタイムで分析し、16の主要領域におけるコンピテンシーを多角的に評価します。',
      'assessment.overviewDescription2': '評価結果では、あなたの強みや成長機会、パーソナリティ特性、モチベーション要因などを科学的根拠に基づいて包括的に分析し、個人最適化された成長プランを提案します。',
      'assessment.duration': '所要時間：約20分',
      'assessment.items': '16領域の包括評価',
      'assessment.previousQuestionAndAnswer': '直前の質問と回答',

      'auth.login': 'ログイン',
      'auth.signup': 'アカウント登録',
      'auth.logout': 'ログアウト',
      'auth.email': 'メールアドレス',
      'auth.password': 'パスワード',
      'auth.confirmPassword': 'パスワード（確認）',
      'auth.displayName': '名前',
      'auth.optional': '（任意）',
      'auth.required': '（必須）',
      'auth.forgotPassword': 'パスワードをお忘れですか？',
      'auth.resetPassword': 'パスワードリセット',
      'auth.sendResetLink': 'リセットリンクを送信',
      'auth.alreadyHaveAccount': 'すでにアカウントをお持ちの方はこちら',
      'auth.dontHaveAccount': 'アカウントをお持ちでない方はこちら',
      'auth.backToLogin': 'ログインに戻る',
      'auth.loginError':
        'ログインに失敗しました。メールアドレスとパスワードを確認してください。',
      'auth.googleLoginError':
        'Googleログインに失敗しました。もう一度お試しください。',
      'auth.loginWithGoogle': 'Googleでログイン',
      'auth.orContinueWith': 'または',
      'auth.signupError':
        'アカウント登録に失敗しました。別のメールアドレスを試すか、後でもう一度お試しください。',
      'auth.resetSuccess':
        'パスワードリセットの手順をメールで送信しました。メールをご確認ください。',
      'auth.resetError':
        'パスワードリセットに失敗しました。メールアドレスを確認して、もう一度お試しください。',
      'auth.passwordMismatch': 'パスワードが一致しません。',
      'auth.passwordTooShort': 'パスワードは6文字以上である必要があります。',
      'auth.fillAllRequired': 'すべての必須項目を入力してください。',

      'result.title': 'コンピテンシー評価結果',
      'result.overallScore': '総合スコア',
      'result.strengths': '強み領域',
      'result.improvements': '改善が必要な領域',
      'result.noStrengths': '特に高いスコアの領域はありません。',
      'result.noImprovements': '特に低いスコアの領域はありません。',
      'result.behavioralAnalysis': '行動特性の分析',
      'result.personalityAnalysis': '性格・パーソナリティの分析',
      'result.stressResistance': 'ストレス耐性',
      'result.workplaceSociability': '職場での社会性',
      'result.motivationFactors': 'モチベーション要因',
      'result.communicationAnalysis': 'コミュニケーション能力',
      'result.leadershipAnalysis': 'リーダーシップ',
      'result.productivityAnalysis': '生産性向上の取り組み',
      'result.problemSolvingAnalysis': '問題解決能力',
      'result.developmentSuggestions': '育成提案',
      'result.downloadPDF': '結果をPDFでダウンロード',
      'result.newAssessment': '新しい評価を開始',
      'result.generating': '評価結果を生成中...',
      'result.analyzing':
        'AIが回答データを分析しています。しばらくお待ちください。',
      'result.error': 'エラーが発生しました',
      'result.notFound': '評価結果が見つかりません',
      'result.dataError':
        'データが不足しているか、処理中にエラーが発生しました。',
      'result.pdfGenerating': 'PDFを生成中...',

      'history.title': '評価履歴',
      'history.loading': '履歴を読み込み中...',
      'history.error': '履歴の読み込みに失敗しました',
      'history.fetchError': '評価履歴の取得に失敗しました',
      'history.deleteError': '評価結果の削除に失敗しました',
      'history.noAssessments': '評価履歴がありません',
      'history.startNew': '新しい評価を開始',
      'history.score': 'スコア',
      'history.view': '詳細',
      'history.delete': '削除',
      'history.confirmDelete': 'この評価結果を削除してもよろしいですか？',
      'history.individualViewNotImplemented': '個別評価表示は現在実装中です',

      'admin.title': '管理者ダッシュボード',
      'admin.subtitle': 'システム全体の評価結果とユーザー名簿',
      'admin.refreshData': 'データ更新',
      'admin.dashboard': 'ダッシュボード',
      'admin.analytics': '分析',
      'admin.noDataTitle': '評価データがありません',
      'admin.noDataDescription': 'まだ評価が実行されていないか、データベースに接続できません。',
      'admin.refreshDataButton': 'データを再取得',
      'admin.startAssessment': '評価を実行',
      'admin.monthly': '今月',
      'admin.quarterly': '四半期',
      'admin.yearly': '年間',
      'admin.csvExport': 'CSV出力',
      'admin.currentPlan': '契約情報',
      'admin.invoiceHistory': '請求履歴',
      'admin.paymentMethod': '支払い方法',
      'admin.currentPlanInfo': '現在の契約情報',
      'admin.pdfExport': 'PDF出力',
      'admin.totalAssessments': '総評価数',
      'admin.uniqueUsers': 'ユニークユーザー数',
      'admin.averageScore': '平均スコア',
      'admin.outOf100': '/ 100点満点',
      'admin.highPerformers': 'ハイパフォーマー比率',
      'admin.lowPerformers': 'ローパフォーマー比率',
      'admin.scoreDistribution': 'スコア分布',
      'admin.distributionAnalysis': 'スコア分布の統計分析',
      'admin.histogram': 'ヒストグラム',
      'admin.performanceBreakdown': 'パフォーマンス構成',
      'admin.categoryDistribution': 'カテゴリー別分布',
      'admin.levelAnalysis': 'レベル分析',
      'admin.trendAnalysis': '評価トレンド分析',
      'admin.sixMonthTrend': '過去6ヶ月の推移データ',
      'admin.timeSeriesAnalysis': '時系列分析',
      'admin.compositeIndex': '複合指標',
      'admin.distributionHeatmap': '分布ヒートマップ',
      'admin.heatmapDescription': '期間フィルタ適用・ユーザー最新評価のみ（重複なし）',
      'admin.matrixAnalysis': 'マトリックス分析',
      'admin.strengthMap': '強み領域マップ',
      'admin.radarDescription': 'コンピテンシー分布のレーダー分析',
      'admin.analysis360': '360° 分析',
      'admin.detailedScoreAnalysis': '詳細スコア分析',
      'admin.rangeAnalysis': 'スコア帯域別の詳細分析',
      'admin.scoreRanges': 'スコア帯域',
      'admin.highPerformerRange': '85点以上 (ハイパフォーマー)',
      'admin.aboveStandardRange': '70-84点 (標準以上)',
      'admin.standardRange': '60-69点 (標準)',
      'admin.users': 'ユーザー名簿',
      'admin.settings': '設定',
      'admin.userList': 'ユーザー一覧',
      'admin.userName': 'ユーザー名',
      'admin.userEmail': 'メールアドレス',
      'admin.userRole': 'ロール',
      'admin.roleAdmin': '管理者',
      'admin.roleUser': '一般ユーザー',
      'admin.setRole': 'ロール設定',
      'admin.saveSuccess': '設定が保存されました',
      'admin.saveError': '設定の保存に失敗しました',
      'admin.confirmRoleChange':
        'このユーザーのロールを変更してもよろしいですか？',
      'admin.noPermission': 'この操作を実行する権限がありません',
      'admin.fetchError': 'データの取得に失敗しました',
      'admin.assessments': '評価結果',
      'admin.assessmentList': '評価結果一覧',
      'admin.date': '日付',
      'admin.user': 'ユーザー',
      'admin.score': 'スコア',
      'admin.category': 'カテゴリ',
      'admin.actions': '操作',
      'admin.view': '表示',
      'admin.noName': '名前なし',
      'admin.makeAdmin': '管理者にする',
      'admin.makeUser': '一般ユーザーにする',

      // 請求管理
      'billing.title': '請求・プラン管理',
      'billing.subtitle': '契約プランの確認・変更、請求情報の管理を行います',
      'billing.showDebug': 'デバッグ表示',
      'billing.hideDebug': 'デバッグ非表示',
      'billing.currentPlan': '現在のプラン',
      'billing.planHistory': 'プラン履歴',
      'billing.usage': '利用状況',
      'billing.invoices': '請求書',
      'billing.paymentMethod': '支払い方法',
      'billing.loading': '読み込み中...',
      'billing.error': 'エラーが発生しました',
      'billing.noSubscription': 'サブスクリプションがありません',
      'billing.free': 'フリー',
      'billing.monthly': '月額',
      'billing.yearly': '年額',
      'billing.changePlan': 'プラン変更',
      'billing.cancelSubscription': 'サブスクリプションのキャンセル',
      'billing.downloadInvoice': '請求書をダウンロード',
      'billing.updatePayment': '支払い方法を更新',
      'billing.authRequired': '認証が必要です',
      'billing.loginRequired': 'ログインしてください',
      'billing.checkingAuth': '認証状態を確認中...',
      'billing.requiresLogin': '請求管理機能を利用するにはログインが必要です。',
      'billing.goToLogin': 'ログイン画面へ',
      'billing.recheckAuth': '認証状態を再確認',
      'billing.loadingBilling': '請求情報を読み込み中...',
      'billing.systemError': '請求管理システムエラー',
      'billing.retry': '再試行',
      'billing.runDebug': 'デバッグ実行',
      'billing.authInfo': '認証情報:',
      'billing.user': 'ユーザー:',
      'billing.session': 'セッション:',
      'billing.authStatus': '認証状態:',
      'billing.valid': '有効',
      'billing.invalid': '無効',
      'billing.authenticated': '認証済み',
      'billing.notAuthenticated': '未認証',
      'billing.unknown': '不明',
      'billing.subscriptionNotFound': 'サブスクリプションが見つかりません',
      'billing.selectPlanPrompt': 'プランを選択してサブスクリプションを開始してください。',
      'billing.selectPlan': 'プランを選択',
      'billing.authUser': '認証ユーザー:',
      'billing.currentPlanInfo': '現在の契約情報',
      'billing.planName': 'プラン名',
      'billing.contractStatus': '契約状態',
      'billing.monthlyFee': '月額料金',
      'billing.evaluationFee': '評価単価',
      'billing.perEvaluation': '/ 回',
      'billing.maxUsers': '利用可能ユーザー数',
      'billing.unlimited': '無制限',
      'billing.users': '名',
      'billing.contractStartDate': '契約開始日',
      'billing.changePlanButton': 'プランを変更する',
      'billing.cancelContract': '契約をキャンセル',
      'billing.canceling': 'キャンセル中...',
      'billing.confirmCancel': '本当に契約をキャンセルしますか？',
      'billing.contractCanceled': '契約をキャンセルしました',
      'billing.cancelError': 'キャンセルエラー:',
      'billing.contractInfo': '契約情報',
      'billing.invoiceHistory': '請求履歴',
      'billing.billingPeriod': '請求期間:',
      'billing.subtotal': '小計',
      'billing.tax': '消費税（10%）',
      'billing.total': '合計',
      'billing.issueDate': '発行日',
      'billing.dueDate': '支払期限',
      'billing.paymentDate': '支払日',
      'billing.downloading': 'ダウンロード中...',
      'billing.pdf': 'PDF',
      'billing.noInvoices': '請求履歴がありません',
      'billing.mainCard': 'メインのカード',
      'billing.notSet': '未設定',
      'billing.expiryDate': '有効期限:',
      'billing.active': 'アクティブ',
      'billing.updateCard': 'カード情報を更新',
      'billing.addNewCard': '新しいカードを追加',
      'billing.manageInPortal': 'Stripe Customer Portalで管理',
      'billing.securityInfo': '支払い情報のセキュリティについて',
      'billing.securityPoint1': 'カード情報はPCI DSS準拠のStripeによって暗号化保存',
      'billing.securityPoint2': '当社のサーバーにカード番号は保存されません',
      'billing.securityPoint3': 'すべての決済処理はSSL暗号化通信で保護',
      'billing.securityPoint4': '不正検知システムによる24時間監視',
      'billing.planChange': 'プラン変更',
      'billing.close': '閉じる',
      'billing.currentPlanLabel': '現在のプラン',
      'billing.perMonth': '/月',
      'billing.trialDays': 'トライアル:',
      'billing.days': '日間',
      'billing.trialEvaluations': 'トライアル評価:',
      'billing.times': '回',
      'billing.processing': '処理中...',
      'billing.contactUs': 'お問い合わせ',
      'billing.changeTo': 'このプランに変更',
      'billing.changeToPlan': 'このプランに変更',
      'billing.notice': 'ご注意',
      'billing.planChangeNotice': 'プラン変更は即座に反映され、日割り計算で請求されます。ダウングレードの場合、一部機能が制限される可能性があります。',
      'billing.loadingPlans': 'プラン情報を読み込み中...',
      'billing.changeNotice': 'ご注意:',
      'billing.changeNoticeText': 'プラン変更は即座に反映され、日割り計算で請求されます。ダウングレードの場合、一部機能が制限される可能性があります。',
      'billing.currentUsage': '現在の利用状況',
      'billing.nextBillingAmount': '次回請求予定額',
      'billing.thisMonth': '今月',
      'billing.assessmentCount': '評価実施数',
      'billing.usageFee': '利用料金:',
      'billing.billingDate': '請求日:',
      'billing.notSetDate': '未設定',
      'billing.estimate': '※予測値です',
      'billing.trialPeriod': 'トライアル期間中',
      'billing.trialRemaining': '残り評価回数:',
      'billing.trialEndDate': 'トライアル終了日:',
      'billing.debugInfo': 'デバッグ情報',
      'billing.stripeCustomerId': 'Stripe顧客IDが見つかりません',
      'billing.paymentMethodError': '支払い方法管理エラー:',
      'billing.checkoutError': 'Checkout session creation failed',
      'billing.planChangeError': 'プラン変更エラー:',
      'billing.companyNotFound': '企業情報が見つかりません',
      'billing.authError': '認証エラー (続行可能):',
      'billing.dataFetchError': 'データ取得エラー (表示可能):',
      'billing.cardFetchError': 'カード情報の取得に失敗しました',
      'billing.setupSessionError': 'セットアップセッションの作成に失敗しました',
      'billing.portalSessionError': 'Customer Portalセッションの作成に失敗しました',
      'billing.unknownAction': '不明なアクションです',
      'billing.noContract': '契約なし',
      'billing.fetchingPlanInfo': 'プラン情報取得中',
      'billing.starterPlan': 'スタータープラン',
      'billing.lightPlan': 'ライトプラン',
      'billing.standardPlan': 'スタンダードプラン',
      'billing.enterprisePlan': 'エンタープライズプラン',
      'billing.errorFallback': 'エラー時フォールバック',
      'billing.planError': 'プラン変更時にエラーが発生しました',
      'billing.pdfGenerationError': 'PDF生成に失敗しました',
      'billing.pdfDownloadError': 'PDFダウンロードエラー:',
      'billing.loginPrompt': '評価結果を保存するにはログインが必要です',
      'billing.tableAccessCheck': 'テーブルアクセス確認',
      'billing.pastDue': '支払い遅延',
      'billing.canceled': 'キャンセル済み',
      'billing.pending': '請求中',
      'billing.paid': '支払済',
      'billing.paymentFailed': '支払い失敗',
      'billing.void': '無効',
      'billing.companyDefaultName': 'FeelFlow株式会社',
      'billing.test': 'テスト',

      // コンピテンシー管理パネル
      'competency.panel.title.system': 'システム設定',
      'competency.panel.subtitle.system': '企業価値と評価基準の管理',
      'competency.panel.companyValuesTab': '企業価値',
      'competency.panel.evaluationCriteriaTab': '評価基準',
      'competency.panel.addNewValue': '新規追加',
      'competency.panel.editValue': '編集',
      'competency.panel.deleteValue': '削除',
      'competency.panel.otherSettingsTitle': 'その他の設定',
      'competency.panel.minQuestionsPerAreaLabel': '領域別最小質問数',
      'competency.panel.feedbackDetailLabel': 'フィードバック詳細度',
      'competency.panel.loadingSettings': '設定データを読み込み中...',
      'competency.panel.error': 'エラー',
      'competency.panel.fetchError': '企業理念データの取得に失敗しました（開発モードで動作中）:',
      'competency.panel.success': '成功',
      'competency.panel.saveSuccess': '変更が正常に保存されました',
      'competency.panel.companyValues': '企業価値',
      'competency.panel.evaluationCriteria': '評価基準',
      'competency.panel.evaluationCriteriaSettings': '評価基準設定',
      'competency.panel.addNew': '新規追加',
      'competency.panel.edit': '編集',
      'competency.panel.delete': '削除',
      'competency.panel.confirmDelete': 'この企業価値を削除してもよろしいですか？',
      'competency.panel.saveChanges': '変更を保存',
      'competency.panel.saving': '保存中...',
      'competency.panel.saveError': '変更の保存に失敗しました。',
      'competency.panel.customerFirst': 'お客様第一主義',
      'competency.panel.customerFirstDesc': 'お客様の満足を最優先に考え、期待を超える価値を提供し続ける',
      'competency.panel.innovation': 'イノベーション',
      'competency.panel.innovationDesc': '新しい技術やアイデアを積極的に取り入れ、革新的なソリューションを創造する',
      'competency.panel.teamwork': 'チームワーク',
      'competency.panel.teamworkDesc': '多様性を尊重し、協力と信頼に基づいたチーム作りを推進する',
      'competency.panel.continuousImprovement': '継続的改善',
      'competency.panel.continuousImprovementDesc': '現状に満足せず、常により良い方法を追求し続ける',
      'competency.panel.performanceThreshold': 'パフォーマンス閾値',
      'competency.panel.highPerformerThreshold': 'ハイパフォーマー閾値:',
      'competency.panel.lowPerformerThreshold': 'ローパフォーマー閾値:',
      'competency.panel.points': '点',
      'competency.panel.otherSettings': 'その他の設定',
      'competency.panel.minQuestionsPerArea': '領域別最小質問数',
      'competency.panel.feedbackDetail': 'フィードバック詳細度',
      'competency.panel.feedbackLow': '低',
      'competency.panel.feedbackMedium': '中',
      'competency.panel.feedbackHigh': '高',
      'competency.panel.modalEditTitle': '企業価値を編集',
      'competency.panel.modalAddTitle': '新しい企業価値を追加',
      'competency.panel.name': '名前',
      'competency.panel.description': '説明',
      'competency.panel.namePlaceholder': '企業価値の名前',
      'competency.panel.descriptionPlaceholder': '企業価値の説明',
      'competency.panel.cancel': 'キャンセル',
      'competency.panel.save': '保存',
      'competency.panel.nameRequired': '名前は必須です',
      'competency.panel.aiModelTab': 'AIモデル設定',
      'competency.panel.aiModelSettings': 'AIモデル設定',
      'competency.panel.aiModel.primaryModel': 'メインAIモデル',
      'competency.panel.aiModel.saveSuccess': 'AIモデル設定を保存しました',
      'competency.panel.aiModel.cost.high': '高コスト',
      'competency.panel.aiModel.cost.medium': '中コスト',
      'competency.panel.aiModel.cost.low': '低コスト',
      'competency.panel.aiModel.adaptiveSelection': 'アダプティブ選択設定',
      'competency.panel.aiModel.enableAdaptive': 'タスクの複雑度に応じたモデル選択',
      'competency.panel.aiModel.adaptiveDescription': '簡単なタスクには低コストモデルを使用します',
      'competency.panel.aiModel.fallbackModel': 'フォールバックモデル',
      'competency.panel.aiModel.complexityThreshold': '複雑度しきい値',
      'competency.panel.aiModel.simpleTask': '簡単なタスク',
      'competency.panel.aiModel.complexTask': '複雑なタスク',
      'competency.panel.aiModel.currentSettings': '現在の設定',
      'competency.panel.aiModel.primary': 'メイン',
      'competency.panel.aiModel.fallback': 'フォールバック',
      'competency.panel.aiModel.threshold': 'しきい値',

      // 質問表示
      'question.preparing': '質問を準備中',
      'question.ragFetching': 'RAG機能で質問を取得中...',
      'question.searchingDb': 'competency_evaluation_itemsテーブルから検索中',
      'question.error': 'エラーが発生しました',
      'question.retry': '再試行',
      'question.fetchError': '質問の取得に失敗しました。もう一度お試しください。',
      'question.evaluationError': '評価結果の生成に失敗しました。もう一度お試しください。',
      'question.notFound': '質問が見つかりません。',
      'question.generating': 'AI評価結果を生成中',
      'question.analyzing': '回答を分析してコンピテンシー評価を作成中',
      'question.questionNumber': '質問',
      'question.fromDatabase': 'データベースから取得',
      'question.aiGenerated': 'AI生成',
      'question.completed': '完了',
      'question.situations': 'シチュエーション',
      'question.matchScore': 'RAG取得',
      'question.answer': '回答:',
      'question.yes': 'はい',
      'question.no': 'いいえ',
      'question.neither': 'どちらでもない',
      'question.unsure': 'わからない',
      'question.followUpNeeded': 'フォローアップ:',
      'question.needed': '必要',
      'question.notNeeded': '不要',
      'question.backToPrevious': '前の質問に戻る',

      // 強み領域ランキング
      'admin.strengthRanking': '強み領域ランキング',
      'admin.latestAssessmentOnly': '最新評価のみ（ユニークユーザーベース）',
      'admin.topAreas': 'TOP 8領域',
      'admin.holders': '保有者数',
      'admin.people': '人',
      'admin.possessionRate': '保有率',

      // トップ強み領域
      'admin.topStrengthAreas': 'トップ強み領域',
      'admin.userBaseTop6': 'ユーザーベース TOP 6',
      'admin.possessionRateShort': '保有率',

      // カテゴリ
      'category.highPerformer': 'ハイパフォーマー',
      'category.aboveStandard': '標準以上',
      'category.standard': '標準',
      'category.belowStandard': '標準以下',

      // ヒートマップとチャート
      'chart.scoreRange': 'スコア範囲',
      'chart.competencyArea': 'コンピテンシー領域',
      'chart.userCount': 'ユーザー数',
      'chart.sampleUser': 'サンプルユーザー',
      'chart.noData': 'データなし',
      'chart.competency': 'コンピテンシー',
      'chart.points': '点',
      'chart.colorIntensity': '色の濃さがユーザー数を表示',
      'chart.hoverDetails': 'セルをホバーで詳細表示',
      'chart.latestOnly': 'ユーザーの最新評価のみ反映（重複なし）',
      'chart.scoreDistribution': 'スコア範囲別の分布を可視化',
      'chart.userDistributionHeatmap': 'コンピテンシー別ユーザー分布ヒートマップ',
      'chart.userDistributionHeatmapSection': 'コンピテンシー別ユーザー分布ヒートマップ - 2025年版',

      // コンピテンシー領域
      'competency.leadership': 'リーダーシップ',
      'competency.communication': 'コミュニケーション',
      'competency.problemSolving': '問題解決',
      'competency.productivity': '生産性向上',
      'competency.teamwork': 'チームワーク',
      'competency.stressResistance': 'ストレス耐性',
      'competency.motivation': 'モチベーション',
      'competency.personality': '性格・パーソナリティ',
      'competency.others': 'その他',
      'competency.learningDesire': '学習意欲',
      'competency.creativity': '創造性',
      'competency.adaptability': '適応力',
      'competency.timeManagement': '時間管理',
      'competency.decisionMaking': '意思決定',
      'competency.planning': '計画性',
      'competency.responsibility': '責任感',
      'competency.cooperation': '協調性',
      'competency.selfManagement': '自己管理',
      'competency.analyticalSkill': '分析力',
      'competency.commitment': 'コミット力',

      // ユーザー名簿
      'users.title': 'ユーザー名簿',
      'users.subtitle': 'ユーザー情報の閲覧と管理',
      'users.search': '検索',
      'users.searchPlaceholder': 'ユーザー名またはメールアドレスで検索',
      'users.sortBy': 'ソート',
      'users.sortByName': '名前',
      'users.sortByEmail': 'メールアドレス',
      'users.sortByRole': '権限',
      'users.sortByCreated': '作成日',
      'users.sortAsc': '昇順',
      'users.sortDesc': '降順',
      'users.totalUsers': '総ユーザー数',
      'users.adminUsers': '管理者数',
      'users.regularUsers': '一般ユーザー数',
      'users.newUser': '新規ユーザー作成',
      'users.email': 'メールアドレス',
      'users.password': 'パスワード',
      'users.fullName': '氏名',
      'users.role': '権限',
      'users.department': '部署',
      'users.createUser': 'ユーザー作成',
      'users.editUser': 'ユーザー編集',
      'users.deleteUser': 'ユーザー削除',
      'users.confirmDelete': 'このユーザーを削除してもよろしいですか？',
      'users.selectUser': 'ユーザーを選択',
      'users.showAssessments': '評価履歴を表示',
      'users.hideAssessments': '評価履歴を非表示',
      'users.assessmentHistory': '評価履歴',
      'users.noAssessments': '評価履歴がありません',
      'users.actions': 'アクション',
      'users.edit': '編集',
      'users.delete': '削除',
      'users.adminRole': '管理者',
      'users.userRole': 'ユーザー',
      'users.defaultUser': 'ユーザー',
      'users.loading': '読み込み中...',
      'users.error': 'エラーが発生しました',
      'users.success': '正常に処理されました',
      'users.createSuccess': 'ユーザーを作成しました',
      'users.updateSuccess': 'ユーザー情報を更新しました',
      'users.deleteSuccess': 'ユーザーを削除しました',
      'users.createError': 'ユーザー作成に失敗しました',
      'users.updateError': 'ユーザー更新に失敗しました',
      'users.deleteError': 'ユーザー削除に失敗しました',
      'users.noUsers': 'ユーザーが見つかりません',
      'users.permissionDenied': '権限がありません',
      'users.debugInfo': 'デバッグ情報',
      'users.showDebug': 'デバッグ表示',
      'users.hideDebug': 'デバッグ非表示',

      // Landing Page
      'landing.companyName': 'Feel Competency',
      'landing.tagline': '隠れた才能を感じ取る',
      'landing.heroDescription': '採用で最も重要なのは、履歴書に書かれていない「潜在能力」です。AIと独自メソッドで、一人ひとりの真の価値を100%可視化し、企業の未来を創る人材を発見します。',
      'landing.nav.problem': '課題',
      'landing.nav.solution': '解決策',
      'landing.nav.evaluation': '評価項目',
      'landing.nav.admin': '管理画面',
      'landing.stats.accuracy': '% 予測精度',
      'landing.stats.companies': '+ 導入企業',
      'landing.stats.retention': '% 定着率向上',
      'landing.cta.startAssessment': '評価を開始',
      'landing.cta.viewDetails': '詳細を見る',
      'landing.visual.cognitiveAbility': '認知能力',
      'landing.visual.interpersonal': '対人関係',
      'landing.visual.executionPower': '実行力',
      'landing.visual.potential': '潜在能力',
      'landing.problem.title': '採用における\n3つの限界',
      'landing.problem.subtitle': '従来の採用手法では見えない、真の人材価値を発見する必要があります',
      'landing.problem.item1.title': '隠れた才能の見落とし',
      'landing.problem.item1.description': '書類選考や面接だけでは、潜在的な能力を持つ人材を見逃してしまいます。真の実力を発揮するまでに時間がかかる人材を適切に評価できていません。',
      'landing.problem.item2.title': '早期離職率の高さ',
      'landing.problem.item2.description': 'せっかく採用した人材が3年以内に離職。従来の適性検査では組織適合性や定着性を正確に予測できず、採用投資が無駄になってしまいます。',
      'landing.problem.item3.title': '配属後のミスマッチ',
      'landing.problem.item3.description': '採用時の評価と実際の職務能力にギャップが発生。適切な部署への配属や個人の強みを活かした育成計画が立てられていません。',
      'landing.solution.title': 'Feel Competencyが\n全てを変える',
      'landing.solution.description1': '従来の適性検査は「不適性」を排除することに重点を置いていました。しかし、Feel Competencyは全く異なるアプローチを取ります。',
      'landing.solution.description2': 'AIを活用した独自の分析エンジンで、個人の「隠れた才能」と「成長ポテンシャル」を発見し、企業の成長に直結する人材価値を100%可視化します。',
      'landing.solution.feature1': '97%の定着率予測精度を実現',
      'landing.solution.feature2': '1000+の評価指標による多面的分析',
      'landing.solution.feature3': '将来の能力発揮時期を予測',
      'landing.solution.feature4': '個人最適化された成長計画を提案',
      'landing.solution.feature5': '企業文化との適合度を詳細分析',
      'landing.comparison.title': '従来手法 vs Feel Competency',
      'landing.comparison.traditional': '従来の適性検査',
      'landing.comparison.traditional1': '不適性要素の排除',
      'landing.comparison.traditional2': '現在の能力のみ評価',
      'landing.comparison.traditional3': '画一的な評価基準',
      'landing.comparison.traditional4': '短期的な判断',
      'landing.comparison.traditional5': '限定的な予測精度',
      'landing.comparison.feelcompetency': 'Feel Competency',
      'landing.comparison.feelcompetency1': '隠れた才能の発見',
      'landing.comparison.feelcompetency2': '成長ポテンシャル予測',
      'landing.comparison.feelcompetency3': '個別最適化評価',
      'landing.comparison.feelcompetency4': '長期的価値創造',
      'landing.comparison.feelcompetency5': '97%の高精度予測',
      'landing.evaluation.title': '多面的評価項目',
      'landing.evaluation.subtitle': '独自の評価フレームワークで、人材の隠れた価値を発見します',
      'landing.evaluation.areas.leadership': 'リーダーシップ',
      'landing.evaluation.areas.leadership_desc': 'チームを導き、成果を出す能力',
      'landing.evaluation.areas.communication': 'コミュニケーション',
      'landing.evaluation.areas.communication_desc': '効果的な意思疎通と協調性',
      'landing.evaluation.areas.problemSolving': '問題解決力',
      'landing.evaluation.areas.problemSolving_desc': '課題を発見し解決する力',
      'landing.evaluation.areas.personality': '性格・パーソナリティ',
      'landing.evaluation.areas.personality_desc': '個人の特性と職務適合性',
      'landing.evaluation.areas.stressResistance': 'ストレス耐性',
      'landing.evaluation.areas.stressResistance_desc': 'プレッシャー下での対応力',
      'landing.evaluation.areas.sociability': '社会性',
      'landing.evaluation.areas.sociability_desc': '組織内での協調と適応',
      'landing.evaluation.areas.motivation': 'モチベーション',
      'landing.evaluation.areas.motivation_desc': '仕事への意欲と情熱',
      'landing.evaluation.areas.productivity': '生産性',
      'landing.evaluation.areas.productivity_desc': '効率的な成果創出能力',
      'landing.evaluation.areas.harassment': 'ハラスメントリスク',
      'landing.evaluation.areas.harassment_desc': '職場環境への影響評価',
      'landing.evaluation.areas.mentalHealth': 'メンタルヘルス',
      'landing.evaluation.areas.mentalHealth_desc': '心理的健康状態の把握',
      'landing.evaluation.areas.compliance': 'コンプライアンス',
      'landing.evaluation.areas.compliance_desc': '規範意識と倫理観',
      'landing.cta.finalTitle': '採用の未来を\n今すぐ体験',
      'landing.cta.finalDescription': '無料デモで、隠れた才能を発見する方法をご覧ください',
      'landing.cta.tryNow': '無料で試してみる',
      'landing.cta.adminLogin': '管理者ログイン',
      'landing.footer.copyright': '© 2024 Feel Competency. All rights reserved.',
      'landing.footer.privacy': 'プライバシーポリシー',
      'landing.footer.terms': '利用規約',
      'landing.footer.contact': 'お問い合わせ',

      // Set Password Page
      'setPassword.title': 'パスワード設定',
      'setPassword.description': 'アカウントのパスワードを設定してください',
      'setPassword.invalidLink': '無効なリンクです',
      'setPassword.passwordRequired': 'パスワードを入力してください',
      'setPassword.passwordTooShort': 'パスワードは6文字以上必要です',
      'setPassword.passwordMismatch': 'パスワードが一致しません',
      'setPassword.newPassword': '新しいパスワード',
      'setPassword.newPasswordPlaceholder': '6文字以上',
      'setPassword.confirmPassword': 'パスワード（確認）',
      'setPassword.confirmPasswordPlaceholder': 'もう一度入力',
      'setPassword.settingPassword': '設定中...',
      'setPassword.setPasswordButton': 'パスワードを設定',
      'setPassword.success': 'パスワードが設定されました！',
      'setPassword.redirecting': '3秒後にログインページへ移動します...',
      'setPassword.setPasswordError': 'パスワードの設定に失敗しました',
      'setPassword.passwordSettingError': 'パスワード設定エラー:',

      // Competency Assessment
      'competency.area.personality.title': '性格・パーソナリティ',
      'competency.area.personality.description': '個人の性格特性や行動傾向を評価し、仕事との適合性や強みと弱みを把握します。',
      'competency.area.personality.selfAwareness': '自己認識',
      'competency.area.personality.adaptability': '適応性',
      'competency.area.personality.dependability': '信頼性',
      
      'competency.area.stress.title': 'ストレス耐性',
      'competency.area.stress.description': 'プレッシャーやストレスの多い状況下での対応能力を評価します。',
      'competency.area.stress.pressureHandling': 'プレッシャー対応',
      'competency.area.stress.emotionalStability': '感情安定性',
      'competency.area.stress.recovery': '回復力',
      
      'competency.area.sociability.title': '職場での社会性',
      'competency.area.sociability.description': '職場における人間関係の構築や維持の能力を評価します。',
      'competency.area.sociability.teamwork': 'チームワーク',
      'competency.area.sociability.respect': '尊重',
      'competency.area.sociability.networkBuilding': 'ネットワーク構築',
      
      'competency.area.motivation.title': 'モチベーション',
      'competency.area.motivation.description': '仕事への意欲や動機づけの要因を評価します。',
      'competency.area.motivation.intrinsicMotivation': '内発的動機',
      'competency.area.motivation.achievement': '達成欲求',
      'competency.area.motivation.growth': '成長意欲',
      
      'competency.area.communication.title': 'コミュニケーション',
      'competency.area.communication.description': '情報の伝達や意見交換の効果的な能力を評価します。',
      'competency.area.communication.listening': '傾聴力',
      'competency.area.communication.expression': '表現力',
      'competency.area.communication.feedback': 'フィードバック',
      
      'competency.area.leadership.title': 'リーダーシップ',
      'competency.area.leadership.description': 'チームを導き、影響を与え、目標達成に導く能力を評価します。',
      'competency.area.leadership.vision': 'ビジョン',
      'competency.area.leadership.influence': '影響力',
      'competency.area.leadership.empowerment': 'エンパワーメント',
      
      'competency.area.productivity.title': '生産性向上',
      'competency.area.productivity.description': '効率的に業務を遂行し、結果を出す能力を評価します。',
      'competency.area.productivity.timeManagement': '時間管理',
      'competency.area.productivity.planning': '計画立案',
      'competency.area.productivity.execution': '実行力',
      
      'competency.area.problemSolving.title': '問題解決',
      'competency.area.problemSolving.description': '課題を特定し、効果的な解決策を見つける能力を評価します。',
      'competency.area.problemSolving.analysis': '分析力',
      'competency.area.problemSolving.creativity': '創造性',
      'competency.area.problemSolving.decisionMaking': '意思決定',
      
      'competency.area.harassment.title': 'ハラスメント防止',
      'competency.area.harassment.description': '職場におけるハラスメントの認識と防止に関する意識と行動を評価します。',
      'competency.area.harassment.awareness': '認識・意識',
      'competency.area.harassment.prevention': '予防策',
      'competency.area.harassment.response': '対応力',
      
      'competency.area.mentalHealth.title': 'メンタルヘルス',
      'competency.area.mentalHealth.description': '心理的な健康状態の維持と管理に関する能力を評価します。',
      'competency.area.mentalHealth.selfCare': 'セルフケア',
      'competency.area.mentalHealth.stressManagement': 'ストレス管理',
      'competency.area.mentalHealth.resilience': '回復力・レジリエンス',
      
      'competency.area.compliance.title': 'コンプライアンス',
      'competency.area.compliance.description': '法令や社内規定の理解と遵守に関する姿勢と行動を評価します。',
      'competency.area.compliance.understanding': '理解度',
      'competency.area.compliance.adherence': '遵守姿勢',
      'competency.area.compliance.riskAwareness': 'リスク認識',
      
      'competency.selectAreaTitle': '評価したいコンピテンシー領域を選択してください',
      'competency.selectAreaDescription': 'あなたの能力を多角的に評価するため、最適なコンピテンシー領域を選択してください',

      // Error Messages
      'error.noAdminPermission': '管理者権限がありません。一般ユーザーとしてログインしている可能性があります。',
      'error.adminPermissionCheckFailed': '管理者権限の確認に失敗しました',
      'error.assessmentFetchFailed': '評価結果の取得に失敗しましたが、他のデータを取得中です...',
      'error.noDataFound': 'データが見つかりません。評価が実行されていない可能性があります。',
      'error.dataFetchFailed': 'データの取得に失敗しました',
      'error.dashboardNotLoaded': 'ダッシュボードが読み込まれていません',
      'error.pdfGenerationFailed': 'PDF生成に失敗しました',
      'alert.moveToAssessment': '評価画面に移動します',
      
      // Assessment Detail View
      'assessmentDetail.title': '評価結果詳細',
      'assessmentDetail.back': '戻る',
      'assessmentDetail.loading': '評価結果を読み込み中...',
      'assessmentDetail.error': 'エラー',
      'assessmentDetail.retry': '再試行',
      'assessmentDetail.notFound': '評価結果が見つかりません',
      'assessmentDetail.noPermission': 'この評価結果を表示する権限がありません',
      'assessmentDetail.pdfExport': 'PDF出力',
      'assessmentDetail.overallResult': '総合評価結果',
      'assessmentDetail.overallScore': '総合スコア',
      'assessmentDetail.evaluationCategory': '評価カテゴリ',
      'assessmentDetail.strengthAreas': '強み領域',
      'assessmentDetail.improvementAreas': '改善が必要な領域',
      'assessmentDetail.noStrengthAreas': '特に突出した強み領域は見られません。',
      'assessmentDetail.noImprovementAreas': '特に改善が必要な領域は見られません。',
      'assessmentDetail.behavioralAnalysis': '行動特性の分析',
      'assessmentDetail.developmentSuggestions': '育成提案',
      'assessmentDetail.questionHistory': '質問と回答の履歴',
      'assessmentDetail.answer': '回答',
      'assessmentDetail.evaluationInfo': '評価情報',
      'assessmentDetail.evaluationDate': '評価日時',
      'assessmentDetail.evaluee': '評価対象者',
      'assessmentDetail.questionCount': '質問数',
      'assessmentDetail.questions': '問',
      'assessmentDetail.evaluationId': '評価ID',
      'assessmentDetail.pdfGenerating': 'PDFを生成中...',
      'assessmentDetail.pdfGenerationFailed': 'PDF生成に失敗しました',
      
      // Billing Additional
      'billing.notLoaded': '評価結果が読み込まれていません',
      
      // History
      'history.description': '過去の評価結果を確認し、あなたの成長の軌跡を振り返ることができます',
      'history.totalScore': '総合スコア',
      'history.of100': '/ 100点',
      
      // Answer options
      'answer.yes': 'はい',
      'answer.no': 'いいえ',
      'answer.neutral': 'どちらでもない',
      'answer.unknown': 'よくわからない',
    },
  },
  en: {
    translation: {
      'app.title': 'AI Feel Competency',
      'app.start': 'Start',
      'app.admin': 'Admin Panel',
      'app.history': 'Assessment History',
      'app.back': 'Back to Main',
      'app.backToHistory': 'Back to History',
      'app.loading': 'Loading...',
      'app.error': 'An error occurred',
      'app.retry': 'Retry',
      'app.yes': 'Yes',
      'app.no': 'No',
      'app.neutral': 'Neither',
      'app.unknown': 'Not sure',
      'app.save': 'Save',
      'app.cancel': 'Cancel',
      'app.competencyAssessment': 'Competency Assessment',
      'app.aiAnalysisDescription': 'AI analyzes your capabilities across 11 domains\nGenerate detailed assessment reports instantly',

      // Competency Assessment Tool
      'assessment.title': 'AI-Driven Competency Assessment Tool',
      'assessment.subtitle': 'Scientifically analyze your potential with innovative AI technology',
      'assessment.aiDrivenAnalysis': 'AI-Driven Analysis',
      'assessment.nameLabel': 'Evaluee Name',
      'assessment.namePlaceholder': 'Please enter your name',
      'assessment.startButton': 'Start AI Assessment',
      'assessment.progressLabel': 'Progress',
      'assessment.preparingQuestions': 'Preparing AI questions...',
      'assessment.processing': 'Processing...',
      'assessment.welcomeTitle': 'Welcome to AI-Driven Competency Assessment',
      'assessment.welcomeDescription': 'We will comprehensively evaluate your ability characteristics using cutting-edge AI technology.',
      'assessment.nextQuestion': 'Next Question',
      'assessment.finishAssessment': 'Complete Assessment',
      'assessment.progress': 'Progress',
      'assessment.answerScale': 'Answer Scale',
      'assessment.scale1': 'Not at all applicable',
      'assessment.scale2': 'Not very applicable',
      'assessment.scale3': 'Neither',
      'assessment.scale4': 'Somewhat applicable',
      'assessment.scale5': 'Very applicable',
      'assessment.analyzing': 'Analyzing...',
      'assessment.generatingResults': 'Generating results...',
      'assessment.resultsTitle': 'AI Analysis Results',
      'assessment.overview': 'Assessment Overview',
      'assessment.overviewDescription1': 'This tool uses AI to analyze your responses in real-time and comprehensively evaluates competencies across 11 key areas.',
      'assessment.overviewDescription2': 'The assessment results provide a comprehensive analysis of your strengths, growth opportunities, personality traits, and motivation factors based on scientific evidence, proposing personalized growth plans.',
      'assessment.duration': 'Duration: Approximately 20 minutes',
      'assessment.items': '11 Areas, 33 Items',
      'assessment.previousQuestionAndAnswer': 'Previous Question and Answer',

      'auth.login': 'Login',
      'auth.signup': 'Sign Up',
      'auth.logout': 'Logout',
      'auth.email': 'Email',
      'auth.password': 'Password',
      'auth.confirmPassword': 'Confirm Password',
      'auth.displayName': 'Name',
      'auth.optional': '(Optional)',
      'auth.required': '(Required)',
      'auth.forgotPassword': 'Forgot Password?',
      'auth.resetPassword': 'Reset Password',
      'auth.sendResetLink': 'Send Reset Link',
      'auth.alreadyHaveAccount': 'Already have an account?',
      'auth.dontHaveAccount': "Don't have an account?",
      'auth.backToLogin': 'Back to Login',
      'auth.loginError': 'Login failed. Please check your email and password.',
      'auth.googleLoginError': 'Google login failed. Please try again.',
      'auth.loginWithGoogle': 'Login with Google',
      'auth.orContinueWith': 'or continue with',
      'auth.signupError':
        'Sign up failed. Please try a different email or try again later.',
      'auth.resetSuccess':
        'Password reset instructions have been sent to your email.',
      'auth.resetError':
        'Password reset failed. Please check your email and try again.',
      'auth.passwordMismatch': 'Passwords do not match.',
      'auth.passwordTooShort': 'Password must be at least 6 characters long.',
      'auth.fillAllRequired': 'Please fill in all required fields.',

      'result.title': 'Competency Assessment Results',
      'result.overallScore': 'Overall Score',
      'result.strengths': 'Strength Areas',
      'result.improvements': 'Areas for Improvement',
      'result.noStrengths': 'No areas with particularly high scores.',
      'result.noImprovements': 'No areas with particularly low scores.',
      'result.behavioralAnalysis': 'Behavioral Analysis',
      'result.personalityAnalysis': 'Personality Analysis',
      'result.stressResistance': 'Stress Resistance',
      'result.workplaceSociability': 'Workplace Sociability',
      'result.motivationFactors': 'Motivation Factors',
      'result.communicationAnalysis': 'Communication Skills',
      'result.leadershipAnalysis': 'Leadership',
      'result.productivityAnalysis': 'Productivity Improvement',
      'result.problemSolvingAnalysis': 'Problem Solving Skills',
      'result.developmentSuggestions': 'Development Suggestions',
      'result.downloadPDF': 'Download Results as PDF',
      'result.newAssessment': 'Start New Assessment',
      'result.generating': 'Generating Assessment Results...',
      'result.analyzing': 'AI is analyzing your response data. Please wait.',
      'result.error': 'An Error Occurred',
      'result.notFound': 'Assessment Results Not Found',
      'result.dataError':
        'Insufficient data or an error occurred during processing.',
      'result.pdfGenerating': 'Generating PDF...',

      'history.title': 'Assessment History',
      'history.loading': 'Loading history...',
      'history.error': 'Failed to load history',
      'history.fetchError': 'Failed to fetch assessment history',
      'history.deleteError': 'Failed to delete assessment result',
      'history.noAssessments': 'No assessment history found',
      'history.startNew': 'Start New Assessment',
      'history.score': 'Score',
      'history.view': 'View',
      'history.delete': 'Delete',
      'history.confirmDelete':
        'Are you sure you want to delete this assessment result?',
      'history.individualViewNotImplemented':
        'Individual assessment view is currently being implemented',

      'admin.title': 'Admin Dashboard',
      'admin.subtitle': 'System-wide assessment results and user management',
      'admin.refreshData': 'Refresh Data',
      'admin.dashboard': 'Dashboard',
      'admin.analytics': 'Analytics',
      'admin.noDataTitle': 'No Assessment Data',
      'admin.noDataDescription': 'No assessments have been completed yet or unable to connect to the database.',
      'admin.refreshDataButton': 'Refresh Data',
      'admin.startAssessment': 'Start Assessment',
      'admin.monthly': 'This Month',
      'admin.quarterly': 'Quarterly',
      'admin.yearly': 'Yearly',
      'admin.csvExport': 'CSV Export',
      'admin.currentPlan': 'Contract Information',
      'admin.invoiceHistory': 'Invoice History',
      'admin.paymentMethod': 'Payment Method',
      'admin.currentPlanInfo': 'Current Contract Information',
      'admin.pdfExport': 'PDF Export',
      'admin.totalAssessments': 'Total Assessments',
      'admin.uniqueUsers': 'Unique Users',
      'admin.averageScore': 'Average Score',
      'admin.outOf100': '/ 100 points',
      'admin.highPerformers': 'High Performers',
      'admin.lowPerformers': 'Low Performers',
      'admin.scoreDistribution': 'Score Distribution',
      'admin.distributionAnalysis': 'Statistical analysis of score distribution',
      'admin.histogram': 'Histogram',
      'admin.performanceBreakdown': 'Performance Breakdown',
      'admin.categoryDistribution': 'Category-wise distribution',
      'admin.levelAnalysis': 'Level Analysis',
      'admin.trendAnalysis': 'Assessment Trend Analysis',
      'admin.sixMonthTrend': 'Past 6 months trend data',
      'admin.timeSeriesAnalysis': 'Time Series Analysis',
      'admin.compositeIndex': 'Composite Index',
      'admin.distributionHeatmap': 'Distribution Heatmap',
      'admin.heatmapDescription': 'Period filter applied - Latest user assessments only (no duplicates)',
      'admin.matrixAnalysis': 'Matrix Analysis',
      'admin.strengthMap': 'Strength Area Map',
      'admin.radarDescription': 'Radar analysis of competency distribution',
      'admin.analysis360': '360° Analysis',
      'admin.detailedScoreAnalysis': 'Detailed Score Analysis',
      'admin.rangeAnalysis': 'Detailed analysis by score range',
      'admin.scoreRanges': 'Score Ranges',
      'admin.highPerformerRange': '85+ points (High Performers)',
      'admin.aboveStandardRange': '70-84 points (Above Standard)',
      'admin.standardRange': '60-69 points (Standard)',
      'admin.users': 'User Management',
      'admin.settings': 'Settings',
      'admin.userList': 'User List',
      'admin.userName': 'User Name',
      'admin.userEmail': 'Email',
      'admin.userRole': 'Role',
      'admin.roleAdmin': 'Admin',
      'admin.roleUser': 'User',
      'admin.setRole': 'Set Role',
      'admin.saveSuccess': 'Settings saved successfully',
      'admin.saveError': 'Failed to save settings',
      'admin.confirmRoleChange':
        "Are you sure you want to change this user's role?",
      'admin.noPermission': "You don't have permission to perform this action",
      'admin.fetchError': 'Failed to fetch data',
      'admin.assessments': 'Assessments',
      'admin.assessmentList': 'Assessment List',
      'admin.date': 'Date',
      'admin.user': 'User',
      'admin.score': 'Score',
      'admin.category': 'Category',
      'admin.actions': 'Actions',
      'admin.view': 'View',
      'admin.noName': 'No Name',
      'admin.makeAdmin': 'Make Admin',
      'admin.makeUser': 'Make User',

      // 請求管理
      'billing.title': 'Billing & Plan Management',
      'billing.subtitle': 'Review and modify your subscription plan, manage billing information',
      'billing.showDebug': 'Show Debug',
      'billing.hideDebug': 'Hide Debug',
      'billing.currentPlan': 'Current Plan',
      'billing.planHistory': 'Plan History',
      'billing.usage': 'Usage',
      'billing.invoices': 'Invoices',
      'billing.paymentMethod': 'Payment Method',
      'billing.loading': 'Loading...',
      'billing.error': 'An error occurred',
      'billing.noSubscription': 'No subscription',
      'billing.free': 'Free',
      'billing.monthly': 'Monthly',
      'billing.yearly': 'Yearly',
      'billing.changePlan': 'Change Plan',
      'billing.cancelSubscription': 'Cancel Subscription',
      'billing.downloadInvoice': 'Download Invoice',
      'billing.updatePayment': 'Update Payment Method',
      'billing.authRequired': 'Authentication Required',
      'billing.loginRequired': 'Please login',
      'billing.checkingAuth': 'Checking authentication status...',
      'billing.requiresLogin': 'Login required to use billing management features.',
      'billing.goToLogin': 'Go to Login',
      'billing.recheckAuth': 'Recheck Authentication',
      'billing.loadingBilling': 'Loading billing information...',
      'billing.systemError': 'Billing System Error',
      'billing.retry': 'Retry',
      'billing.runDebug': 'Run Debug',
      'billing.authInfo': 'Authentication Info:',
      'billing.user': 'User:',
      'billing.session': 'Session:',
      'billing.authStatus': 'Auth Status:',
      'billing.valid': 'Valid',
      'billing.invalid': 'Invalid',
      'billing.authenticated': 'Authenticated',
      'billing.notAuthenticated': 'Not Authenticated',
      'billing.unknown': 'Unknown',
      'billing.subscriptionNotFound': 'No subscription found',
      'billing.selectPlanPrompt': 'Please select a plan to start your subscription.',
      'billing.selectPlan': 'Select Plan',
      'billing.authUser': 'Authenticated User:',
      'billing.currentPlanInfo': 'Current Contract Information',
      'billing.planName': 'Plan Name',
      'billing.contractStatus': 'Contract Status',
      'billing.monthlyFee': 'Monthly Fee',
      'billing.evaluationFee': 'Per Evaluation Fee',
      'billing.perEvaluation': '/ evaluation',
      'billing.maxUsers': 'Available Users',
      'billing.unlimited': 'Unlimited',
      'billing.users': 'users',
      'billing.contractStartDate': 'Contract Start Date',
      'billing.changePlanButton': 'Change Plan',
      'billing.cancelContract': 'Cancel Contract',
      'billing.canceling': 'Canceling...',
      'billing.confirmCancel': 'Are you sure you want to cancel your contract?',
      'billing.contractCanceled': 'Contract has been canceled',
      'billing.cancelError': 'Cancel Error:',
      'billing.contractInfo': 'Contract Information',
      'billing.invoiceHistory': 'Invoice History',
      'billing.billingPeriod': 'Billing Period:',
      'billing.subtotal': 'Subtotal',
      'billing.tax': 'Tax (10%)',
      'billing.total': 'Total',
      'billing.issueDate': 'Issue Date',
      'billing.dueDate': 'Due Date',
      'billing.paymentDate': 'Payment Date',
      'billing.downloading': 'Downloading...',
      'billing.pdf': 'PDF',
      'billing.noInvoices': 'No invoice history',
      'billing.mainCard': 'Primary Card',
      'billing.notSet': 'Not Set',
      'billing.expiryDate': 'Expiry:',
      'billing.active': 'Active',
      'billing.updateCard': 'Update Card',
      'billing.addNewCard': 'Add New Card',
      'billing.manageInPortal': 'Manage in Stripe Customer Portal',
      'billing.securityInfo': 'About Payment Security',
      'billing.securityPoint1': 'Card information is encrypted and stored by PCI DSS compliant Stripe',
      'billing.securityPoint2': 'Card numbers are not stored on our servers',
      'billing.securityPoint3': 'All payment processing is protected by SSL encryption',
      'billing.securityPoint4': '24/7 monitoring by fraud detection system',
      'billing.planChange': 'Change Plan',
      'billing.close': 'Close',
      'billing.currentPlanLabel': 'Current Plan',
      'billing.perMonth': '/month',
      'billing.trialDays': 'Trial:',
      'billing.days': 'days',
      'billing.trialEvaluations': 'Trial Evaluations:',
      'billing.times': 'times',
      'billing.processing': 'Processing...',
      'billing.contactUs': 'Contact Us',
      'billing.changeTo': 'Change to this plan',
      'billing.changeToPlan': 'Change to this plan',
      'billing.notice': 'Notice',
      'billing.planChangeNotice': 'Plan changes take effect immediately and are billed on a prorated basis. Downgrading may limit some features.',
      'billing.loadingPlans': 'Loading plan information...',
      'billing.changeNotice': 'Notice:',
      'billing.changeNoticeText': 'Plan changes take effect immediately and are billed on a prorated basis. Downgrading may limit some features.',
      'billing.currentUsage': 'Current Usage',
      'billing.nextBillingAmount': 'Next Billing Amount',
      'billing.thisMonth': 'This Month',
      'billing.assessmentCount': 'Assessments Conducted',
      'billing.usageFee': 'Usage Fee:',
      'billing.billingDate': 'Billing Date:',
      'billing.notSetDate': 'Not Set',
      'billing.estimate': '* Estimated',
      'billing.trialPeriod': 'Trial Period',
      'billing.trialRemaining': 'Remaining Evaluations:',
      'billing.trialEndDate': 'Trial End Date:',
      'billing.debugInfo': 'Debug Information',
      'billing.stripeCustomerId': 'Stripe Customer ID not found',
      'billing.paymentMethodError': 'Payment method management error:',
      'billing.checkoutError': 'Checkout session creation failed',
      'billing.planChangeError': 'Plan change error:',
      'billing.companyNotFound': 'Company information not found',
      'billing.authError': 'Authentication error (can continue):',
      'billing.dataFetchError': 'Data fetch error (can display):',
      'billing.cardFetchError': 'Failed to fetch card information',
      'billing.setupSessionError': 'Failed to create setup session',
      'billing.portalSessionError': 'Failed to create Customer Portal session',
      'billing.unknownAction': 'Unknown action',
      'billing.noContract': 'No Contract',
      'billing.fetchingPlanInfo': 'Fetching plan information',
      'billing.starterPlan': 'Starter Plan',
      'billing.lightPlan': 'Light Plan',
      'billing.standardPlan': 'Standard Plan',
      'billing.enterprisePlan': 'Enterprise Plan',
      'billing.errorFallback': 'Error Fallback',
      'billing.planError': 'Error occurred during plan change',
      'billing.pdfGenerationError': 'Failed to generate PDF',
      'billing.pdfDownloadError': 'PDF download error:',
      'billing.loginPrompt': 'Login required to save assessment results',
      'billing.signoutError': 'Sign out error:',
      'billing.tableAccessCheck': 'Check Table Access',
      'billing.pastDue': 'Past Due',
      'billing.canceled': 'Canceled',
      'billing.pending': 'Pending',
      'billing.paid': 'Paid',
      'billing.paymentFailed': 'Payment Failed',
      'billing.void': 'Void',
      'billing.companyDefaultName': 'FeelFlow Inc.',
      'billing.test': 'Test',

      // Competency Management Panel
      'competency.panel.title.system': 'System Settings',
      'competency.panel.subtitle.system': 'Company Values and Evaluation Criteria Management',
      'competency.panel.companyValuesTab': 'Company Values',
      'competency.panel.evaluationCriteriaTab': 'Evaluation Criteria',
      'competency.panel.addNewValue': 'Add New',
      'competency.panel.editValue': 'Edit',
      'competency.panel.deleteValue': 'Delete',
      'competency.panel.otherSettingsTitle': 'Other Settings',
      'competency.panel.minQuestionsPerAreaLabel': 'Minimum Questions per Area',
      'competency.panel.feedbackDetailLabel': 'Feedback Detail Level',
      'competency.panel.loadingSettings': 'Loading settings data...',
      'competency.panel.error': 'Error',
      'competency.panel.fetchError': 'Failed to fetch company philosophy data (running in development mode):',
      'competency.panel.success': 'Success',
      'competency.panel.saveSuccess': 'Changes saved successfully',
      'competency.panel.companyValues': 'Company Values',
      'competency.panel.evaluationCriteria': 'Evaluation Criteria',
      'competency.panel.evaluationCriteriaSettings': 'Evaluation Criteria Settings',
      'competency.panel.addNew': 'Add New',
      'competency.panel.edit': 'Edit',
      'competency.panel.delete': 'Delete',
      'competency.panel.confirmDelete': 'Are you sure you want to delete this company value?',
      'competency.panel.saveChanges': 'Save Changes',
      'competency.panel.saving': 'Saving...',
      'competency.panel.saveError': 'Failed to save changes.',
      'competency.panel.customerFirst': 'Customer First',
      'competency.panel.customerFirstDesc': 'Prioritize customer satisfaction and continuously provide value beyond expectations',
      'competency.panel.innovation': 'Innovation',
      'competency.panel.innovationDesc': 'Actively adopt new technologies and ideas to create innovative solutions',
      'competency.panel.teamwork': 'Teamwork',
      'competency.panel.teamworkDesc': 'Respect diversity and promote team building based on cooperation and trust',
      'competency.panel.continuousImprovement': 'Continuous Improvement',
      'competency.panel.continuousImprovementDesc': 'Never be satisfied with the status quo and always pursue better methods',
      'competency.panel.performanceThreshold': 'Performance Threshold',
      'competency.panel.highPerformerThreshold': 'High Performer Threshold:',
      'competency.panel.lowPerformerThreshold': 'Low Performer Threshold:',
      'competency.panel.points': 'points',
      'competency.panel.otherSettings': 'Other Settings',
      'competency.panel.minQuestionsPerArea': 'Minimum Questions per Area',
      'competency.panel.feedbackDetail': 'Feedback Detail Level',
      'competency.panel.feedbackLow': 'Low',
      'competency.panel.feedbackMedium': 'Medium',
      'competency.panel.feedbackHigh': 'High',
      'competency.panel.modalEditTitle': 'Edit Company Value',
      'competency.panel.modalAddTitle': 'Add New Company Value',
      'competency.panel.name': 'Name',
      'competency.panel.description': 'Description',
      'competency.panel.namePlaceholder': 'Company value name',
      'competency.panel.descriptionPlaceholder': 'Company value description',
      'competency.panel.cancel': 'Cancel',
      'competency.panel.save': 'Save',
      'competency.panel.nameRequired': 'Name is required',
      'competency.panel.aiModelTab': 'AI Model Settings',
      'competency.panel.aiModelSettings': 'AI Model Settings',
      'competency.panel.aiModel.primaryModel': 'Primary AI Model',
      'competency.panel.aiModel.saveSuccess': 'AI model settings saved successfully',
      'competency.panel.aiModel.cost.high': 'High Cost',
      'competency.panel.aiModel.cost.medium': 'Medium Cost',
      'competency.panel.aiModel.cost.low': 'Low Cost',
      'competency.panel.aiModel.adaptiveSelection': 'Adaptive Selection Settings',
      'competency.panel.aiModel.enableAdaptive': 'Model selection based on task complexity',
      'competency.panel.aiModel.adaptiveDescription': 'Use low-cost models for simple tasks',
      'competency.panel.aiModel.fallbackModel': 'Fallback Model',
      'competency.panel.aiModel.complexityThreshold': 'Complexity Threshold',
      'competency.panel.aiModel.simpleTask': 'Simple Task',
      'competency.panel.aiModel.complexTask': 'Complex Task',
      'competency.panel.aiModel.currentSettings': 'Current Settings',
      'competency.panel.aiModel.primary': 'Primary',
      'competency.panel.aiModel.fallback': 'Fallback',
      'competency.panel.aiModel.threshold': 'Threshold',

      // Question Display
      'question.preparing': 'Preparing questions',
      'question.ragFetching': 'Fetching questions with RAG...',
      'question.searchingDb': 'Searching in competency_evaluation_items table',
      'question.error': 'An error occurred',
      'question.retry': 'Retry',
      'question.fetchError': 'Failed to fetch questions. Please try again.',
      'question.evaluationError': 'Failed to generate evaluation results. Please try again.',
      'question.notFound': 'No questions found.',
      'question.generating': 'Generating AI evaluation results',
      'question.analyzing': 'Analyzing responses to create competency evaluation',
      'question.questionNumber': 'Question',
      'question.fromDatabase': 'Retrieved from database',
      'question.aiGenerated': 'AI Generated',
      'question.completed': 'completed',
      'question.situations': 'Situation',
      'question.matchScore': 'RAG Retrieved',
      'question.answer': 'Answer:',
      'question.yes': 'Yes',
      'question.no': 'No',
      'question.neither': 'Neither',
      'question.unsure': 'Not sure',
      'question.followUpNeeded': 'Follow-up:',
      'question.needed': 'Needed',
      'question.notNeeded': 'Not needed',
      'question.backToPrevious': 'Back to previous question',

      // 強み領域ランキング
      'admin.strengthRanking': 'Strength Area Ranking',
      'admin.latestAssessmentOnly': 'Latest assessment only (unique user base)',
      'admin.topAreas': 'TOP 8 Areas',
      'admin.holders': 'Holders',
      'admin.people': 'people',
      'admin.possessionRate': 'Possession Rate',

      // トップ強み領域
      'admin.topStrengthAreas': 'Top Strength Areas',
      'admin.userBaseTop6': 'User Base TOP 6',
      'admin.possessionRateShort': 'Possession Rate',

      // カテゴリ
      'category.highPerformer': 'High Performer',
      'category.aboveStandard': 'Above Standard',
      'category.standard': 'Standard',
      'category.belowStandard': 'Below Standard',

      // ヒートマップとチャート
      'chart.scoreRange': 'Score Range',
      'chart.competencyArea': 'Competency Area',
      'chart.userCount': 'User Count',
      'chart.sampleUser': 'Sample User',
      'chart.noData': 'No Data',
      'chart.competency': 'Competency',
      'chart.points': 'points',
      'chart.colorIntensity': 'Color intensity represents user count',
      'chart.hoverDetails': 'Hover cell for details',
      'chart.latestOnly': 'Reflects latest user assessment only (no duplicates)',
      'chart.scoreDistribution': 'Visualizes distribution by score range',
      'chart.userDistributionHeatmap': 'User Distribution Heatmap by Competency',
      'chart.userDistributionHeatmapSection': 'User Distribution Heatmap by Competency - 2025 Edition',

      // コンピテンシー領域
      'competency.leadership': 'Leadership',
      'competency.communication': 'Communication',
      'competency.problemSolving': 'Problem Solving',
      'competency.productivity': 'Productivity',
      'competency.teamwork': 'Teamwork',
      'competency.stressResistance': 'Stress Resistance',
      'competency.motivation': 'Motivation',
      'competency.personality': 'Personality',
      'competency.others': 'Others',
      'competency.learningDesire': 'Learning Desire',
      'competency.creativity': 'Creativity',
      'competency.adaptability': 'Adaptability',
      'competency.timeManagement': 'Time Management',
      'competency.decisionMaking': 'Decision Making',
      'competency.planning': 'Planning',
      'competency.responsibility': 'Responsibility',
      'competency.cooperation': 'Cooperation',
      'competency.selfManagement': 'Self Management',
      'competency.analyticalSkill': 'Analytical Skill',
      'competency.commitment': 'Commitment',

      // ユーザー名簿
      'users.title': 'User Directory',
      'users.subtitle': 'View and manage user information',
      'users.search': 'Search',
      'users.searchPlaceholder': 'Search by name or email',
      'users.sortBy': 'Sort By',
      'users.sortByName': 'Name',
      'users.sortByEmail': 'Email',
      'users.sortByRole': 'Role',
      'users.sortByCreated': 'Created Date',
      'users.sortAsc': 'Ascending',
      'users.sortDesc': 'Descending',
      'users.totalUsers': 'Total Users',
      'users.adminUsers': 'Admin Users',
      'users.regularUsers': 'Regular Users',
      'users.newUser': 'Create New User',
      'users.email': 'Email',
      'users.password': 'Password',
      'users.fullName': 'Full Name',
      'users.role': 'Role',
      'users.department': 'Department',
      'users.createUser': 'Create User',
      'users.editUser': 'Edit User',
      'users.deleteUser': 'Delete User',
      'users.confirmDelete': 'Are you sure you want to delete this user?',
      'users.selectUser': 'Select User',
      'users.showAssessments': 'Show Assessment History',
      'users.hideAssessments': 'Hide Assessment History',
      'users.assessmentHistory': 'Assessment History',
      'users.noAssessments': 'No assessment history',
      'users.actions': 'Actions',
      'users.edit': 'Edit',
      'users.delete': 'Delete',
      'users.adminRole': 'Admin',
      'users.userRole': 'User',
      'users.defaultUser': 'User',
      'users.loading': 'Loading...',
      'users.error': 'An error occurred',
      'users.success': 'Operation completed successfully',
      'users.createSuccess': 'User created successfully',
      'users.updateSuccess': 'User information updated successfully',
      'users.deleteSuccess': 'User deleted successfully',
      'users.createError': 'Failed to create user',
      'users.updateError': 'Failed to update user',
      'users.deleteError': 'Failed to delete user',
      'users.noUsers': 'No users found',
      'users.permissionDenied': 'Permission denied',
      'users.debugInfo': 'Debug Information',
      'users.showDebug': 'Show Debug',
      'users.hideDebug': 'Hide Debug',

      // Landing Page
      'landing.companyName': 'Feel Competency',
      'landing.tagline': 'Sense the Hidden Talent',
      'landing.heroDescription': 'The most important thing in hiring is the "potential" not written on a resume. We discover talent that creates the future of companies by visualizing the true value of each individual 100% with AI and unique methodology.',
      'landing.nav.problem': 'Challenges',
      'landing.nav.solution': 'Solutions',
      'landing.nav.evaluation': 'Evaluation Items',
      'landing.nav.admin': 'Admin Panel',
      'landing.stats.accuracy': '% Prediction Accuracy',
      'landing.stats.companies': '+ Companies Adopted',
      'landing.stats.retention': '% Retention Rate Improvement',
      'landing.cta.startAssessment': 'Start Assessment',
      'landing.cta.viewDetails': 'View Details',
      'landing.visual.cognitiveAbility': 'Cognitive Ability',
      'landing.visual.interpersonal': 'Interpersonal Skills',
      'landing.visual.executionPower': 'Execution Power',
      'landing.visual.potential': 'Potential',
      'landing.problem.title': 'Three Limitations\nin Recruitment',
      'landing.problem.subtitle': 'We need to discover true talent value that cannot be seen with traditional recruitment methods',
      'landing.problem.item1.title': 'Overlooking Hidden Talent',
      'landing.problem.item1.description': 'Document screening and interviews alone miss candidates with potential abilities. We cannot properly evaluate talent that takes time to demonstrate their true capabilities.',
      'landing.problem.item2.title': 'High Early Turnover Rate',
      'landing.problem.item2.description': 'Hired talent leaves within 3 years. Traditional aptitude tests cannot accurately predict organizational fit and retention, resulting in wasted hiring investments.',
      'landing.problem.item3.title': 'Post-Placement Mismatch',
      'landing.problem.item3.description': 'Gaps occur between hiring evaluations and actual job performance. Proper departmental placement and development plans that leverage individual strengths are not being implemented.',
      'landing.solution.title': 'Feel Competency\nChanges Everything',
      'landing.solution.description1': 'Traditional aptitude tests focus on eliminating "unsuitability." However, Feel Competency takes a completely different approach.',
      'landing.solution.description2': 'With our proprietary AI-powered analysis engine, we discover individual "hidden talents" and "growth potential," visualizing 100% of the talent value directly connected to corporate growth.',
      'landing.solution.feature1': 'Achieves 97% retention rate prediction accuracy',
      'landing.solution.feature2': 'Multi-faceted analysis with 1000+ evaluation metrics',
      'landing.solution.feature3': 'Predicts future capability demonstration timing',
      'landing.solution.feature4': 'Proposes individually optimized growth plans',
      'landing.solution.feature5': 'Detailed analysis of corporate culture fit',
      'landing.comparison.title': 'Traditional Methods vs Feel Competency',
      'landing.comparison.traditional': 'Traditional Aptitude Tests',
      'landing.comparison.traditional1': 'Elimination of unsuitable elements',
      'landing.comparison.traditional2': 'Evaluation of current abilities only',
      'landing.comparison.traditional3': 'Uniform evaluation criteria',
      'landing.comparison.traditional4': 'Short-term judgment',
      'landing.comparison.traditional5': 'Limited prediction accuracy',
      'landing.comparison.feelcompetency': 'Feel Competency',
      'landing.comparison.feelcompetency1': 'Discovery of hidden talents',
      'landing.comparison.feelcompetency2': 'Growth potential prediction',
      'landing.comparison.feelcompetency3': 'Individually optimized evaluation',
      'landing.comparison.feelcompetency4': 'Long-term value creation',
      'landing.comparison.feelcompetency5': '97% high-accuracy prediction',
      'landing.evaluation.title': 'Multi-faceted Evaluation',
      'landing.evaluation.subtitle': 'Discover hidden talent value with our unique evaluation framework',
      'landing.evaluation.areas.leadership': 'Leadership',
      'landing.evaluation.areas.leadership_desc': 'Ability to lead teams and deliver results',
      'landing.evaluation.areas.communication': 'Communication',
      'landing.evaluation.areas.communication_desc': 'Effective communication and collaboration',
      'landing.evaluation.areas.problemSolving': 'Problem Solving',
      'landing.evaluation.areas.problemSolving_desc': 'Ability to identify and solve challenges',
      'landing.evaluation.areas.personality': 'Personality',
      'landing.evaluation.areas.personality_desc': 'Personal traits and job compatibility',
      'landing.evaluation.areas.stressResistance': 'Stress Resistance',
      'landing.evaluation.areas.stressResistance_desc': 'Performance under pressure',
      'landing.evaluation.areas.sociability': 'Sociability',
      'landing.evaluation.areas.sociability_desc': 'Organizational fit and adaptation',
      'landing.evaluation.areas.motivation': 'Motivation',
      'landing.evaluation.areas.motivation_desc': 'Drive and passion for work',
      'landing.evaluation.areas.productivity': 'Productivity',
      'landing.evaluation.areas.productivity_desc': 'Efficient value creation ability',
      'landing.evaluation.areas.harassment': 'Harassment Risk',
      'landing.evaluation.areas.harassment_desc': 'Workplace environment impact',
      'landing.evaluation.areas.mentalHealth': 'Mental Health',
      'landing.evaluation.areas.mentalHealth_desc': 'Psychological well-being assessment',
      'landing.evaluation.areas.compliance': 'Compliance',
      'landing.evaluation.areas.compliance_desc': 'Ethics and regulatory awareness',
      'landing.cta.finalTitle': 'Experience the Future\nof Recruitment Now',
      'landing.cta.finalDescription': 'See how to discover hidden talent with our free demo',
      'landing.cta.tryNow': 'Try for Free',
      'landing.cta.adminLogin': 'Admin Login',
      'landing.footer.copyright': '© 2024 Feel Competency. All rights reserved.',
      'landing.footer.privacy': 'Privacy Policy',
      'landing.footer.terms': 'Terms of Service',
      'landing.footer.contact': 'Contact Us',

      // Set Password Page
      'setPassword.title': 'Set Password',
      'setPassword.description': 'Please set a password for your account',
      'setPassword.invalidLink': 'Invalid link',
      'setPassword.passwordRequired': 'Please enter a password',
      'setPassword.passwordTooShort': 'Password must be at least 6 characters',
      'setPassword.passwordMismatch': 'Passwords do not match',
      'setPassword.newPassword': 'New Password',
      'setPassword.newPasswordPlaceholder': '6 characters or more',
      'setPassword.confirmPassword': 'Confirm Password',
      'setPassword.confirmPasswordPlaceholder': 'Enter again',
      'setPassword.settingPassword': 'Setting...',
      'setPassword.setPasswordButton': 'Set Password',
      'setPassword.success': 'Password has been set!',
      'setPassword.redirecting': 'Redirecting to login page in 3 seconds...',
      'setPassword.setPasswordError': 'Failed to set password',
      'setPassword.passwordSettingError': 'Password setting error:',

      // Competency Assessment
      'competency.area.personality.title': 'Personality',
      'competency.area.personality.description': 'Evaluates personal character traits and behavioral tendencies to understand job compatibility, strengths, and weaknesses.',
      'competency.area.personality.selfAwareness': 'Self-Awareness',
      'competency.area.personality.adaptability': 'Adaptability',
      'competency.area.personality.dependability': 'Dependability',
      
      'competency.area.stress.title': 'Stress Resistance',
      'competency.area.stress.description': 'Evaluates the ability to cope under pressure and stressful situations.',
      'competency.area.stress.pressureHandling': 'Pressure Handling',
      'competency.area.stress.emotionalStability': 'Emotional Stability',
      'competency.area.stress.recovery': 'Resilience',
      
      'competency.area.sociability.title': 'Workplace Sociability',
      'competency.area.sociability.description': 'Evaluates the ability to build and maintain relationships in the workplace.',
      'competency.area.sociability.teamwork': 'Teamwork',
      'competency.area.sociability.respect': 'Respect',
      'competency.area.sociability.networkBuilding': 'Network Building',
      
      'competency.area.motivation.title': 'Motivation',
      'competency.area.motivation.description': 'Evaluates work motivation and motivating factors.',
      'competency.area.motivation.intrinsicMotivation': 'Intrinsic Motivation',
      'competency.area.motivation.achievement': 'Achievement Drive',
      'competency.area.motivation.growth': 'Growth Mindset',
      
      'competency.area.communication.title': 'Communication',
      'competency.area.communication.description': 'Evaluates the ability to effectively convey information and exchange ideas.',
      'competency.area.communication.listening': 'Active Listening',
      'competency.area.communication.expression': 'Expression',
      'competency.area.communication.feedback': 'Feedback',
      
      'competency.area.leadership.title': 'Leadership',
      'competency.area.leadership.description': 'Evaluates the ability to lead teams, influence, and guide toward goal achievement.',
      'competency.area.leadership.vision': 'Vision',
      'competency.area.leadership.influence': 'Influence',
      'competency.area.leadership.empowerment': 'Empowerment',
      
      'competency.area.productivity.title': 'Productivity Enhancement',
      'competency.area.productivity.description': 'Evaluates the ability to efficiently execute tasks and deliver results.',
      'competency.area.productivity.timeManagement': 'Time Management',
      'competency.area.productivity.planning': 'Planning',
      'competency.area.productivity.execution': 'Execution',
      
      'competency.area.problemSolving.title': 'Problem Solving',
      'competency.area.problemSolving.description': 'Evaluates the ability to identify issues and find effective solutions.',
      'competency.area.problemSolving.analysis': 'Analytical Skills',
      'competency.area.problemSolving.creativity': 'Creativity',
      'competency.area.problemSolving.decisionMaking': 'Decision Making',
      
      'competency.area.harassment.title': 'Harassment Prevention',
      'competency.area.harassment.description': 'Evaluates awareness and actions related to recognizing and preventing workplace harassment.',
      'competency.area.harassment.awareness': 'Awareness',
      'competency.area.harassment.prevention': 'Prevention',
      'competency.area.harassment.response': 'Response',
      
      'competency.area.mentalHealth.title': 'Mental Health',
      'competency.area.mentalHealth.description': 'Evaluates the ability to maintain and manage psychological well-being.',
      'competency.area.mentalHealth.selfCare': 'Self-Care',
      'competency.area.mentalHealth.stressManagement': 'Stress Management',
      'competency.area.mentalHealth.resilience': 'Resilience',
      
      'competency.area.compliance.title': 'Compliance',
      'competency.area.compliance.description': 'Evaluates attitudes and behaviors related to understanding and adhering to laws and internal regulations.',
      'competency.area.compliance.understanding': 'Understanding',
      'competency.area.compliance.adherence': 'Adherence',
      'competency.area.compliance.riskAwareness': 'Risk Awareness',
      
      'competency.selectAreaTitle': 'Please select the competency area you want to evaluate',
      'competency.selectAreaDescription': 'Select the optimal competency area to comprehensively evaluate your abilities',

      // Error Messages
      'error.noAdminPermission': 'You do not have admin permissions. You may be logged in as a regular user.',
      'error.adminPermissionCheckFailed': 'Failed to verify admin permissions',
      'error.assessmentFetchFailed': 'Failed to fetch assessment results, but retrieving other data...',
      'error.noDataFound': 'No data found. No assessments may have been conducted.',
      'error.dataFetchFailed': 'Failed to fetch data',
      'error.dashboardNotLoaded': 'Dashboard not loaded',
      'error.pdfGenerationFailed': 'Failed to generate PDF',
      'alert.moveToAssessment': 'Moving to assessment screen',
      
      // Assessment Detail View
      'assessmentDetail.title': 'Assessment Result Details',
      'assessmentDetail.back': 'Back',
      'assessmentDetail.loading': 'Loading assessment results...',
      'assessmentDetail.error': 'Error',
      'assessmentDetail.retry': 'Retry',
      'assessmentDetail.notFound': 'Assessment results not found',
      'assessmentDetail.noPermission': 'You do not have permission to view this assessment result',
      'assessmentDetail.pdfExport': 'PDF Export',
      'assessmentDetail.overallResult': 'Overall Assessment Results',
      'assessmentDetail.overallScore': 'Overall Score',
      'assessmentDetail.evaluationCategory': 'Evaluation Category',
      'assessmentDetail.strengthAreas': 'Strength Areas',
      'assessmentDetail.improvementAreas': 'Areas for Improvement',
      'assessmentDetail.noStrengthAreas': 'No particularly outstanding areas of strength.',
      'assessmentDetail.noImprovementAreas': 'No areas requiring particular improvement.',
      'assessmentDetail.behavioralAnalysis': 'Behavioral Analysis',
      'assessmentDetail.developmentSuggestions': 'Development Suggestions',
      'assessmentDetail.questionHistory': 'Question and Answer History',
      'assessmentDetail.answer': 'Answer',
      'assessmentDetail.evaluationInfo': 'Evaluation Information',
      'assessmentDetail.evaluationDate': 'Evaluation Date',
      'assessmentDetail.evaluee': 'Evaluee',
      'assessmentDetail.questionCount': 'Number of Questions',
      'assessmentDetail.questions': 'questions',
      'assessmentDetail.evaluationId': 'Evaluation ID',
      'assessmentDetail.pdfGenerating': 'Generating PDF...',
      'assessmentDetail.pdfGenerationFailed': 'Failed to generate PDF',
      
      // Billing Additional
      'billing.notLoaded': 'Assessment results not loaded',
      
      // History
      'history.description': 'Review past assessment results and reflect on your growth trajectory',
      'history.totalScore': 'Total Score',
      'history.of100': '/ 100 points',
      
      // Answer options
      'answer.yes': 'Yes',
      'answer.no': 'No',
      'answer.neutral': 'Neither',
      'answer.unknown': 'Not sure',
    },
  },
};

export default translations;
